module.exports = "/_next/static/images/f89a56b68b7a18dc63b0e427f75c5af7-robot-xs.png.webp";